import React, { useEffect, useMemo, useState } from 'react';
import Table from '../../../components/Tables/ExpandedTable';
import { headerMaker } from '../../../components/Tables/ExpandedTable/helper';
import { productsHeader } from '../../../redux/modules/table/common';
import { useSelector, useDispatch } from 'react-redux';
import reports from '../../../services/reports';
import rateType from '../../../services/ratingtype';
import Spinner from '../../../components/Spinner';
import { setReportSubData } from '../../../redux/modules/application/actions';
import { makeReport } from '../../../utils/makeReport';
import RangePicker from '../../../components/RangePicker';
import { groupHeaders } from '../../../utils/groupHeader';
import moment from 'moment';
import { setSelectedDate } from '../../../redux/modules/dates/actions';

export default () => {
  const [reportsData, setReportsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSub, setLoadingSub] = useState(false);
  const dispatch = useDispatch();
  const [headers, setHeaders] = useState([]);
  const [newHeader, setNewHeader] = useState([]);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { groupId, userId } = useSelector((state) => state.authReducer);

  useEffect(() => {
    const foo = headerMaker(productsHeader.concat(groupHeaders(newHeader)));
    setHeaders(foo);
  }, [newHeader]);

  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );

  const fetchRateReports = async () => {
    try {
      setLoading(true);
      const data = {
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        group: groupId,
        user: userId,
      };
      const reportData = await reports.getAllRateReport(data);
      const ratesType = await rateType.getAll();
      const myCat = reportData[0]?.categorys.map((i) => i.category);
      setNewHeader(categories.filter((i) => myCat.includes(i._id)));
      const report = makeReport(
        reportData,
        regions,
        groups,
        categories,
        users,
        ratesType
      );
      setReportsData(
        report
          .sort((a, b) => a.total.value - b.total.value)
          .map((item, index) => ({ ...item, id: index + 1 }))
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (!selectedDate.every((item) => item === '')) {
      fetchRateReports();
    }
  }, [dateQuery, categories, regions, groups]);

  const handleSelectgroup = async (id) => {
    try {
      setLoadingSub(true);
      const data = {
        startDate: selectedDate[0],
        endDate: selectedDate[1],
        user: userId,
        category: id,
        group: groupId,
      };
      const resp = await reports.getAllRateReport(data);
      const subCats = categories.filter((item) => item.parent === id);
      const report = subCats.map((item, idx) => {
        const subCat = resp.find((itm) => itm.subCategory === item._id);
        return {
          id: idx + 1,
          name: item?.title,
          total: subCat?.rate
            ? Math.min(Math.round(subCat?.rate), 100)
            : subCat?.rate,
          count: subCat.workCount,

          // regionId: regionId,
        };
      });
      dispatch(setReportSubData(report ? report : []));
      setLoadingSub(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    return () => {
      if (selectedDate[0] === '' && selectedDate[1] === '') {
        const today = moment();
        const yesterday = moment(today).subtract(1, 'days');
        dispatch(
          setSelectedDate([
            today.format('YYYY-MM-DD'),
            yesterday.format('YYYY-MM-DD'),
          ])
        );
      }
    };
  }, []);

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <>
      <div style={{ width: '100%', padding: '20px 0' }}>
        <RangePicker />
      </div>
      <Table
        data={reportsData}
        headers={headers}
        selectgroup={handleSelectgroup}
        loading={loadingSub}
      />
    </>
  );
};
